'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _auth = require('./auth.service');

var _auth2 = _interopRequireDefault(_auth);

var _http = require('./http.service');

var _http2 = _interopRequireDefault(_http);

var _navigation = require('./navigation.service');

var _navigation2 = _interopRequireDefault(_navigation);

var _users = require('./users.service');

var _users2 = _interopRequireDefault(_users);

var _filter = require('./filter.service');

var _filter2 = _interopRequireDefault(_filter);

var _notification = require('./notification.service');

var _notification2 = _interopRequireDefault(_notification);

var _appContext = require('./app-context.service');

var _appContext2 = _interopRequireDefault(_appContext);

var _events = require('./events.service');

var _events2 = _interopRequireDefault(_events);

var _analytics = require('./analytics.service');

var _analytics2 = _interopRequireDefault(_analytics);

var _media = require('./media.service');

var _media2 = _interopRequireDefault(_media);

var _survey = require('./survey.service');

var _survey2 = _interopRequireDefault(_survey);

var _profiles = require('./profiles.service');

var _profiles2 = _interopRequireDefault(_profiles);

var _certificates = require('./certificates.service');

var _certificates2 = _interopRequireDefault(_certificates);

var _checks = require('./checks.service');

var _checks2 = _interopRequireDefault(_checks);

var _jobs = require('./jobs.service');

var _jobs2 = _interopRequireDefault(_jobs);

var _jobRequests = require('./job-requests.service');

var _jobRequests2 = _interopRequireDefault(_jobRequests);

var _affiliates = require('./affiliates.service');

var _affiliates2 = _interopRequireDefault(_affiliates);

var _vouches = require('./vouches.service');

var _vouches2 = _interopRequireDefault(_vouches);

var _mermaid = require('./mermaid.service');

var _mermaid2 = _interopRequireDefault(_mermaid);

var _botFlow = require('./bot-flow.service');

var _botFlow2 = _interopRequireDefault(_botFlow);

var _botManager = require('./bot-manager.service');

var _botManager2 = _interopRequireDefault(_botManager);

var _botSessions = require('./bot-sessions.service');

var _botSessions2 = _interopRequireDefault(_botSessions);

var _businesses = require('./businesses.service');

var _businesses2 = _interopRequireDefault(_businesses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Services = _angular2.default.module('app.common.services', [_angularUiRouter2.default]).factory('AuthService', _auth2.default).factory('HttpService', _http2.default).factory('UsersService', _users2.default).factory('NavigationService', _navigation2.default).factory('FilterService', _filter2.default).factory('NotificationService', _notification2.default).factory('AppContextService', _appContext2.default).factory('EventsService', _events2.default).factory('AnalyticsService', _analytics2.default).factory('MediaService', _media2.default).factory('SurveyService', _survey2.default).factory('ProfilesService', _profiles2.default).factory('CertificatesService', _certificates2.default).factory('ChecksService', _checks2.default).factory('JobsService', _jobs2.default).factory('AffiliatesService', _affiliates2.default).factory('VouchesService', _vouches2.default).factory('MermaidService', _mermaid2.default).factory('BotFlowService', _botFlow2.default).factory('BotManagerService', _botManager2.default).factory('BotSessionsService', _botSessions2.default).factory('BusinessesService', _businesses2.default).factory('JobRequestsService', _jobRequests2.default);

exports.default = Services;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/index.js
 **/